import { createElementVNode as _createElementVNode, openBlock as _openBlock, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, vModelText as _vModelText, normalizeClass as _normalizeClass, withDirectives as _withDirectives, createCommentVNode as _createCommentVNode, createBlock as _createBlock } from "vue";
var _hoisted_1 = {
  class: "navigation-buttons-container"
};
var _hoisted_2 = ["href"];
var _hoisted_3 = {
  class: "row"
};
var _hoisted_4 = {
  class: "offset-lg-3 col-lg-6"
};
var _hoisted_5 = {
  class: "mb-0"
};
var _hoisted_6 = {
  class: "row last-card-indentation"
};
var _hoisted_7 = {
  class: "offset-lg-3 col-lg-6"
};
var _hoisted_8 = {
  class: "ms-2"
};
var _hoisted_9 = {
  class: "mb-0 ifas-card-header-h5"
};
var _hoisted_10 = {
  class: "form-group"
};
var _hoisted_11 = {
  for: "email"
};
var _hoisted_12 = {
  class: "form-text text-muted"
};
var _hoisted_13 = {
  class: "form-group"
};
var _hoisted_14 = {
  for: "title"
};
var _hoisted_15 = {
  class: "form-text text-muted"
};
var _hoisted_16 = {
  class: "form-group"
};
var _hoisted_17 = {
  for: "text"
};
var _hoisted_18 = {
  class: "d-flex justify-content-end mt-3 pt-3 border-top"
};
var _hoisted_19 = {
  class: "mb-0"
};
var _hoisted_20 = {
  class: "pt-4 pb-4"
};
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  var _component_b_col = _resolveComponent("b-col");
  var _component_b_row = _resolveComponent("b-row");
  var _component_v_ifas_card = _resolveComponent("v-ifas-card");
  var _component_v_svg_icon_book_with_pen = _resolveComponent("v-svg-icon-book-with-pen");
  var _component_v_file_input_form_validated = _resolveComponent("v-file-input-form-validated");
  var _component_b_card = _resolveComponent("b-card");
  var _component_v_layout = _resolveComponent("v-layout");
  return _openBlock(), _createBlock(_component_v_layout, null, {
    default: _withCtx(function () {
      return [_createVNode(_component_b_row, {
        class: "limit-height"
      }, {
        default: _withCtx(function () {
          return [_createVNode(_component_b_col, {
            md: "12",
            class: "mb-4 p-0"
          }, {
            default: _withCtx(function () {
              return [_createElementVNode("div", _hoisted_1, [_createElementVNode("a", {
                href: _ctx.originUrl(),
                class: "secondary-button",
                onClick: _cache[0] || (_cache[0] = function () {
                  return $options.goBack && $options.goBack.apply($options, arguments);
                })
              }, [_cache[6] || (_cache[6] = _createElementVNode("svg", {
                class: "icon-highlight-color me-2",
                width: "12",
                height: "8",
                viewBox: "0 0 12 8",
                fill: "none",
                xmlns: "http://www.w3.org/2000/svg"
              }, [_createElementVNode("path", {
                d: "M10.6665 4L1.33317 4",
                "stroke-linecap": "round"
              }), _createElementVNode("path", {
                d: "M4.6001 0.666708L1.33343 4.00004L4.6001 7.33337",
                "stroke-linecap": "round",
                "stroke-linejoin": "round"
              })], -1 /* CACHED */)), _createTextVNode(" " + _toDisplayString(_ctx.$t("contact_form.back_button")), 1 /* TEXT */)], 8 /* PROPS */, _hoisted_2)])];
            }),
            _: 1 /* STABLE */
          })];
        }),
        _: 1 /* STABLE */
      }), _createElementVNode("div", _hoisted_3, [_createElementVNode("div", _hoisted_4, [_createVNode(_component_v_ifas_card, {
        class: "mb-4 p-5",
        nonCollapsible: true,
        header: _ctx.$t('contact_form.header')
      }, {
        default: _withCtx(function () {
          return [_createElementVNode("p", _hoisted_5, _toDisplayString(_ctx.$t("contact_form.description")), 1 /* TEXT */)];
        }),
        _: 1 /* STABLE */
      }, 8 /* PROPS */, ["header"])])]), _createElementVNode("div", _hoisted_6, [_createElementVNode("div", _hoisted_7, [_createElementVNode("form", {
        onSubmit: _cache[5] || (_cache[5] = function () {
          return $options.sendForm && $options.sendForm.apply($options, arguments);
        })
      }, [!$data.formSend ? (_openBlock(), _createBlock(_component_v_ifas_card, {
        key: 0,
        class: "mb-4",
        nonCollapsible: true,
        header: "Kontaktní formulář"
      }, {
        header: _withCtx(function () {
          return [_createElementVNode("div", _hoisted_8, [_createElementVNode("h4", _hoisted_9, _toDisplayString(_ctx.$t("contact_form.title")), 1 /* TEXT */)])];
        }),
        icon: _withCtx(function () {
          return [_createVNode(_component_v_svg_icon_book_with_pen, {
            dimensions: 36
          })];
        }),
        default: _withCtx(function () {
          return [_createVNode(_component_b_card, {
            class: "inner-card"
          }, {
            default: _withCtx(function () {
              return [_createElementVNode("div", _hoisted_10, [_createElementVNode("label", _hoisted_11, _toDisplayString(_ctx.$t("contact_form.email_label")) + ":", 1 /* TEXT */), _withDirectives(_createElementVNode("input", {
                "onUpdate:modelValue": _cache[1] || (_cache[1] = function ($event) {
                  return $data.form.email = $event;
                }),
                type: "email",
                class: _normalizeClass(["form-control", {
                  'is-invalid': !$options.emailIsValid
                }]),
                id: "email"
              }, null, 2 /* CLASS */), [[_vModelText, $data.form.email]]), _createElementVNode("small", _hoisted_12, _toDisplayString(_ctx.$t("contact_form.email_hint")), 1 /* TEXT */), _createElementVNode("div", {
                class: _normalizeClass(["invalid-feedback", {
                  'd-inline': !$options.emailIsValid
                }])
              }, _toDisplayString(_ctx.$t("contact_form.email_error")), 3 /* TEXT, CLASS */)]), _createElementVNode("div", _hoisted_13, [_createElementVNode("label", _hoisted_14, _toDisplayString(_ctx.$t("contact_form.title_label")), 1 /* TEXT */), _withDirectives(_createElementVNode("input", {
                "onUpdate:modelValue": _cache[2] || (_cache[2] = function ($event) {
                  return $data.form.title = $event;
                }),
                type: "text",
                class: _normalizeClass(["form-control", {
                  'is-invalid': !$options.titleIsValid
                }]),
                id: "title"
              }, null, 2 /* CLASS */), [[_vModelText, $data.form.title, void 0, {
                trim: true
              }]]), _createElementVNode("small", _hoisted_15, _toDisplayString(_ctx.$t("contact_form.title_hint")), 1 /* TEXT */), _createElementVNode("div", {
                class: _normalizeClass(["invalid-feedback", {
                  'd-inline': !$options.titleIsValid
                }])
              }, _toDisplayString(_ctx.$t("contact_form.title_error")), 3 /* TEXT, CLASS */)]), _createElementVNode("div", _hoisted_16, [_createElementVNode("label", _hoisted_17, _toDisplayString(_ctx.$t("contact_form.content_label")), 1 /* TEXT */), _withDirectives(_createElementVNode("textarea", {
                "onUpdate:modelValue": _cache[3] || (_cache[3] = function ($event) {
                  return $data.form.text = $event;
                }),
                class: "form-control",
                id: "text",
                rows: "3"
              }, null, 512 /* NEED_PATCH */), [[_vModelText, $data.form.text]])]), _createVNode(_component_v_file_input_form_validated, {
                label: _ctx.$t('contact_form.attachment_label'),
                description: _ctx.$t('contact_form.attachment_hint'),
                value: $data.form.attachment,
                "onUpdate:value": _cache[4] || (_cache[4] = function ($event) {
                  return $data.form.attachment = $event;
                }),
                inputId: "file-upload",
                rules: ""
              }, null, 8 /* PROPS */, ["label", "description", "value"]), _createCommentVNode(" Přesuneme tlačítko přímo do body karty "), _createElementVNode("div", _hoisted_18, [_createElementVNode("button", {
                "data-cy": "contactsSendBtn",
                class: _normalizeClass([{
                  disabled: !$options.formIsValid
                }, "primary-button"]),
                type: "submit"
              }, _toDisplayString(_ctx.$t("contact_form.send_button")), 3 /* TEXT, CLASS */)])];
            }),
            _: 1 /* STABLE */
          })];
        }),
        _: 1 /* STABLE */
      })) : _createCommentVNode("v-if", true), $data.formSend ? (_openBlock(), _createBlock(_component_v_ifas_card, {
        key: 1,
        class: "mb-4"
      }, {
        header: _withCtx(function () {
          return [_createElementVNode("h4", _hoisted_19, _toDisplayString(_ctx.$t("contact_form.title")), 1 /* TEXT */)];
        }),
        default: _withCtx(function () {
          return [_createElementVNode("p", _hoisted_20, _toDisplayString(_ctx.$t("contact_form.form_sent")), 1 /* TEXT */)];
        }),
        _: 1 /* STABLE */
      })) : _createCommentVNode("v-if", true)], 32 /* NEED_HYDRATION */)])])];
    }),
    _: 1 /* STABLE */
  });
}